export default "__VITE_ASSET__COe0Cqtj__"